'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDatabase = undefined;

var _Database = require('./Database');

var _Database2 = _interopRequireDefault(_Database);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createDatabase = _Database2.default;
exports.default = _Database2.default;


//////////////////
// WEBPACK FOOTER
// ../~/redux-orm/lib/db/index.js
// module id = 1129
// module chunks = 0